/** Erreur IAM rejetée (401/403 ou refresh token invalide) — pas une panne réseau. */
export function isAuthRejectionError(error: unknown): boolean {
  if (!error || typeof error !== "object") return false;

  const status = (error as { status?: number }).status;
  if (status === 401 || status === 403) return true;

  if (error instanceof Error) {
    const msg = error.message.toLowerCase();
    return (
      msg.includes("invalid refresh token") ||
      msg.includes("token revoked") ||
      msg.includes("unauthorized")
    );
  }

  return false;
}
